import React from "react";
import { MergeFinancialAccountsResponse } from "@common/dto/financialAccount/mergeFinancialAccounts/merge-financial-accounts-response.dto";
import { Transaction } from "@common/types/transaction";
import { BothModifiedConflict } from "@common/dto/financialAccount/mergeFinancialAccounts/both-modified-conflict.dto";
// oxlint-disable-next-line no-restricted-imports -- Legacy migration debt — do not copy into new code.
import { Collapsible } from "@design-system/Collapsible/Collapsible";
import styles from "./BothModifiedConflicts.module.scss";
import { BothModifiedConflictResolving } from "./BothModifiedConflictResolving";

interface Props {
    conflicts: MergeFinancialAccountsResponse["bothModifiedConflicts"];
    resolutions: number[];
    onResolve: (
        conflict: BothModifiedConflict,
        transaction: Transaction,
    ) => void;
}

export const BothModifiedConflicts: React.FC<Props> = ({
    conflicts,
    resolutions,
    onResolve,
}) => {
    const header = (
        <div className={styles.header}>
            <main>
                <p>
                    Following transactions were modified in both accounts.
                    Please select which version to keep in every case.
                </p>
            </main>
        </div>
    );
    return (
        <Collapsible header={header}>
            <div className={styles.bothModifiedConflicts}>
                {conflicts.map((conflict) => (
                    <BothModifiedConflictResolving
                        key={conflict.transactionFromDestination.id}
                        conflict={conflict}
                        resolutions={resolutions}
                        onResolve={onResolve}
                    />
                ))}
            </div>
        </Collapsible>
    );
};
